import { Injectable } from '@angular/core';
import { Span, SpanStatusCode } from '@opentelemetry/api';
import { isObject } from 'lodash';
import { LogOtelUtilsService } from './log-otel-utils.service';
import {
    LOG_OTEL_DEBUG,
    LOG_OTEL_ERROR,
    LOG_OTEL_LOG,
    LOG_OTEL_WARN,
    LogOtelMessage,
    LogOtelUser,
} from './models';

@Injectable({
    providedIn: 'root',
})
export class LogOtelService {
    constructor(private _utils: LogOtelUtilsService) {}

    setUser(user: LogOtelUser) {
        this._utils.setUser(user);
    }

    error(message: string, info?: unknown): void {
        this.sendTrace(LOG_OTEL_ERROR, message, info);
    }

    log(message: string, info?: unknown): void {
        this.sendTrace(LOG_OTEL_LOG, message, info);
    }
    warn(message: string, info?: unknown): void {
        this.sendTrace(LOG_OTEL_WARN, message, info);
    }
    debug(message: string, info?: unknown): void {
        this.sendTrace(LOG_OTEL_DEBUG, message, info);
    }

    jsError(message: string, error: Error, info: unknown): void {
        this._utils.getTracer().startActiveSpan('JS Error', (span: Span) => {
            this.setJsErrorSpan(span, message, error, info);
        });
    }

    setJsErrorSpan(span: Span, message: string, error: Error, info: unknown) {
        span.setAttribute('message', message);
        span.setAttribute('jsError', true);
        span.setAttribute('name', error.name);
        span.setAttribute('stack', error.stack ?? '');
        span.setStatus({ code: SpanStatusCode.ERROR, message: message });
        console.log(span);
        this.setInfoAttributes(info, span);

        // Be sure to end the span!
        span.end();
    }

    setInfoAttributes(info: unknown, span: Span) {
        isObject(info)
            ? Object.entries(info).forEach(([key, value]) =>
                  span.setAttribute(key, value),
              )
            : null;
    }

    sendTrace(level: string, message: string, info?: unknown) {
        this._utils
            .getTracer()
            .startActiveSpan(LogOtelMessage(level, message), (span: Span) => {
                this.setTraceSpans(span, level, message, info);
            });
    }

    setTraceSpans(span: Span, level: string, message: string, info: unknown) {
        span.setAttribute('message', LogOtelMessage(level, message));
        span.setAttribute('level', level);
        span.addEvent('log', {
            message: message,
            level: level,
        });
        this.setInfoAttributes(info, span);

        span.setStatus({
            code:
                level === LOG_OTEL_ERROR
                    ? SpanStatusCode.ERROR
                    : SpanStatusCode.OK,
            message: message,
        });

        // Be sure to end the span!
        span.end();
    }
}
